module.exports = __webpack_public_path__ + "static/media/lekeplass.401209b0.svg";